import { round } from 'lodash'
import { formatNumber } from '../../../utility'

const getBarTotalPlugin = (
  suffix: string,
  toFullNumber: boolean = false,
  limit: boolean = false,
  enableRound: boolean = true,
  isDoubleBar: boolean = false,
) => {
  return {
    id: 'barTotalPlugin',
    afterDatasetsDraw: (chart) => {
      const {
        ctx,
        scales: { x, y },
        data,
      } = chart

      data.labels.forEach((_, dataIndex) => {
        let total = 0
        if (isDoubleBar) {
          total = data.datasets.reduce((acc, dataset) => {
            if (dataset.data[dataIndex] > acc) {
              return dataset.data[dataIndex]
            }
            return acc
          }, 0)
        } else {
          data.datasets.forEach((dataset) => {
            const val = dataset.data[dataIndex]
            if (typeof val === 'number') {
              total += val
            }
          })
        }

        if (!x || !y) return

        let diff = 0
        if (!!limit && Array.isArray(data.datasets?.[0]?.limits)) {
          diff = data.datasets[0].limits[dataIndex] - total
        }

        // Convert that sum to a pixel on the y-axis
        const xPos = x.getPixelForValue(dataIndex)
        const yPos = y.getPixelForValue(total)

        // Draw the text above the bar
        ctx.save()
        ctx.fillStyle = '#000'
        ctx.font = '12px sans-serif'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'bottom'

        // Draw the total value
        let totalText = `${formatNumber(enableRound ? round(total, 2) : total)}${suffix}`

        if (isDoubleBar) {
          totalText = data.datasets.reduce((acc, dataset) => {
            if (!acc) {
              return `${formatNumber(enableRound ? round(dataset.data[dataIndex], 2) : dataset.data[dataIndex])}${suffix}`
            } else {
              return `${acc} // ${formatNumber(enableRound ? round(dataset.data[dataIndex], 2) : dataset.data[dataIndex])}${suffix}`
            }
          }, null)
        }

        if (!!limit) {
          // Measure both texts to center them together
          const limitLabel = `(${diff > 0 ? '+' : ''}${formatNumber(enableRound ? round(diff, 2) : diff)}${suffix})`
          const totalWidth = ctx.measureText(totalText).width
          const limitWidth = ctx.measureText(limitLabel).width

          // Draw total text, positioned to be centered with limit label
          ctx.fillText(totalText, xPos - limitWidth / 2, yPos - 2)

          // Draw the limit label in red
          ctx.fillStyle = diff > 0 ? '#53af4a' : '#FF0000'
          ctx.fillText(limitLabel, xPos + totalWidth / 2 + 4, yPos - 2)
        } else {
          // If no limit label, just center the total
          ctx.fillText(totalText, xPos, yPos - 2)
        }

        ctx.restore()
      })
    },
  }
}

export default getBarTotalPlugin
